import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import {
  formatAmount,
  HandlePurchaseRequestStatus,
  printData,
} from "../../../utility/CommonFunctions";
import moment from "moment";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import CreateVoucherModal from "../Voucher/CreateVoucherModal";
import Logs from "../../Logs/Logs";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import CommonTable from "../../../components/comman/CommonTable";
import DownloadIcon from "../../../components/Icons/DownloadIcon";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { useSelector } from "react-redux";
import AddTdsModal from "../PaymentTickets/AddTdsModal";
import AlertModal from "../PaymentTickets/AlertModel";
import MainHeading from "../../../components/comman/MainHeading";

export default function SalaryTicketDetails() {
  let { id } = useParams();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const [dataLoading, setDataLoading] = useState(true);
  const [state, setState] = useState({
    salaryTicketData: {},
    siteBudget: [],
    loading: false,
    IncreaseLoading: false,
  });
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    VoucherList: [],
    siteList: [],
    searchQuery: "",
    sortByDate: "",
    year: "",
    siteId: "",
    downloadLoading: false,
    taxableAmount: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState({
    approveRejectModal: false,
    createVoucherModel: false,
  });

  const [alertModal, setAlertModal] = useState(false);
  const toggleAlertModal = () => {
    setAlertModal(!alertModal);
  };
  const toggle = (type) => {
    printData(type);
    setModal((prevModal) => ({
      ...prevModal,
      approveRejectModal:
        type === "approveReject"
          ? !prevModal.approveRejectModal
          : prevModal.approveRejectModal,
      createVoucherModel:
        type === "voucher"
          ? !prevModal.createVoucherModel
          : prevModal.createVoucherModel,
    }));
  };

  useEffect(() => {
    GetSalaryTicketDetail();
  }, []);

  const GetSalaryTicketDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_salary_ticket_detail + `salaryTicketId=${id}`;
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setState((pre) => ({
          ...pre,
          salaryTicketData: response?.data,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  useEffect(() => {
    GetVoucherList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates?.pageSize]);

  const GetVoucherList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_voucher +
      MainFilterHandler(pageStates) +
      `&salaryTicketId=${id}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.voucher?.map((item) => ({
          ...item,
          recieverName:
            item?.Transactions?.[0]?.referenceName ||
            item?.Transactions?.[0]?.accountHolderName,
          paymentTicketType: item?.paymentticket?.type,
          transDate: moment(item?.transactionDate).format("DD-MM-YYYY"),
          stNumber: item?.salaryticket?.ticketNumber,
          siteName: item?.salaryticket?.site?.name,
          amount: formatAmount(item?.Transactions?.[0]?.amount),
          createdBy: item?.Transactions?.[0]?.user?.name,
          paymentMethods: item?.Transactions?.[0]?.paymentMethod,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          VoucherList: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const handleReqStatus = (status, reason = "") => {
    setIsLoading(true);

    let postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    callApi(
      apiUrl.update_salary_ticket_status + `?salaryTicketId=${id}`,
      option
    )
      .then((res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetSalaryTicketDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle("approveReject");
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const HandleView = (data) => {
    navigate(RoutesLink.voucher_detail + `/${data?.id}`);
  };

  const TableHeading = [
    { value: "voucherNumber", label: "Payment Advisory NO." },
    { value: "stNumber", label: "ST NO." },
    { value: "recieverName", label: "Reciever Name" },
    { value: "transDate", label: "Date" },
    { value: "siteName", label: "Site" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentMethods", label: "Payment Method" },
    { value: "amount", label: "Amount" },
  ];

  const HandleDownloadPA = async (data) => {
    const submitData = {
      voucherId: [data?.id],
    };
    let options = {
      method: "POST",
      data: submitData,
    };

    const API = apiUrl?.generate_payment_advisory;
    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));
      const response = await callApi(API, options);
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Payment Advisory.pdf`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // clean up
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
    }
  };

  const ActionData = [
    // {
    //   label: "download",
    //   className: "btn btn-link",
    //   icon: <DownloadIcon />,
    //   disabled: pageStates?.downloadLoading,
    //   title: "download",
    //   clickHandler: HandleDownloadPA,
    // },
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  return (
    <>
      {dataLoading && <BgBlurLoader />}
      {pageStates?.downloadLoading && BgBlurLoader()}
      <div className="content container-fluid">
        <MainHeading
          showBackButton={true}
          title={"Salary Ticket Details"}
        />
        <form action="">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <ul
                        className={
                          dataLoading
                            ? "row list-unstyled mt-4 loading-skeleton"
                            : "row list-unstyled mt-4"
                        }
                      >
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              ST NO. :-
                            </span>
                            {state?.salaryTicketData?.ticketNumber
                              ? state?.salaryTicketData?.ticketNumber
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              {state?.salaryTicketData?.site?.type === "office"
                                ? "Office" : state?.salaryTicketData?.site?.type === "site"
                                  ? "Site" : "--"}
                            </span>
                            {state?.salaryTicketData?.site?.name
                              ? state?.salaryTicketData?.site?.name
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Salary Type :-
                            </span>
                            {state?.salaryTicketData?.site?.type === "office" ? (
                              <span className="badge bg-success fw-normal rounded-pill fs-6 px-3 py-1">
                                Office
                              </span>
                            ) : state?.salaryTicketData?.site?.type === "site" ? (
                              <span className="badge bg-primary fw-normal rounded-pill fs-6 px-3 py-1">
                                Site
                              </span>
                            ) : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Month :-
                            </span>
                            {state?.salaryTicketData?.month || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Created On :-
                            </span>
                            {state?.salaryTicketData?.createdAt
                              ? moment(
                                state?.salaryTicketData?.createdAt
                              ).format("DD-MM-YYYY")
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Created By :-
                            </span>
                            {state?.salaryTicketData?.user?.name || "--"}{" "}
                            {state?.salaryTicketData?.user?.designation
                              ?.name && (
                                <span className="text-muted fs-5">
                                  (
                                  {
                                    state?.salaryTicketData?.user?.designation
                                      ?.name
                                  }
                                  )
                                </span>
                              )}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Total Amount :-
                            </span>
                            {formatAmount(
                              state?.salaryTicketData?.totalAmount
                            ) || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Remaining Amount :-
                            </span>
                            {formatAmount(
                              state?.salaryTicketData?.remainingAmount
                            ) || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Status :-
                            </span>
                            {HandlePurchaseRequestStatus(
                              state?.salaryTicketData?.status
                            )}
                          </p>
                        </li>
                        {state?.salaryTicketData?.rejectReason && (
                          <li className="col-12 col-md-6 col-lg-12">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Reject Reason :-
                              </span>
                              {state?.salaryTicketData?.rejectReason || "--"}
                            </p>
                          </li>
                        )}
                        <li className="col-12 col-md-6 col-lg-12">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Description :-
                            </span>
                            {state?.salaryTicketData?.description || "--"}
                          </p>
                        </li>

                      </ul>
                    </div>

                    <div className="col-12 ">
                      <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                        <h4 className="fs-3 rajdhani-semibold my-4 ">
                          User's Salary Details
                        </h4>
                      </div>

                      <div>
                        <table className="table mt-3">
                          <thead>
                            <tr>
                              <th className="text-start">Employee Code</th>
                              <th className="text-start">Employee Name</th>
                              <th className="text-start">Net Pay</th>
                            </tr>
                          </thead>
                          <tbody>
                            {state?.salaryTicketData?.salaryticketitems?.map(
                              (item, i) => {
                                return (
                                  <tr key={i}>
                                    <td className="desc-wrapper text-start">
                                      {item?.usersalary?.user?.employeeCode ||
                                        "--"}
                                    </td>
                                    <td className="desc-wrapper text-start">
                                      {item?.usersalary?.user?.name || "--"}
                                    </td>
                                    <td className="desc-wrapper text-start">
                                      {formatAmount(item?.amount)}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex align-items-center justify-content-center">
                        <h4 className="fs-3 rajdhani-semibold my-4">
                          Total Amount :{" "}
                          {formatAmount(state?.salaryTicketData?.totalAmount)}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        {!dataLoading && state?.salaryTicketData?.canChangeStatus && (
          <div className="d-flex align-items-center justify-content-end gap-3">
            <button
              className="btn btn-danger px-5"
              type="button"
              onClick={() => {
                setModalType("reject");
                toggle("approveReject");
              }}
            >
              Reject
            </button>
            <button
              className="btn btn-success px-5"
              type="button"
              onClick={() => {
                setModalType("approve");
                toggle("approveReject");
              }}
            >
              Approve
            </button>
          </div>
        )}

        {state?.salaryTicketData?.canCreateVoucher &&
          userDetails?.designation?.canCreate?.includes("voucher") && (
            <div className="d-flex gap-2 justify-content-end">
              <button
                className="btn btn-primary px-5"
                type="button"
                onClick={() => {
                  if (state?.salaryTicketData?.canInsertTDS) {
                    toggleAlertModal();
                  } else {
                    toggle("voucher");
                  }
                }}
              >
                Create Payment Advisory
              </button>
            </div>
          )}

        {(state?.salaryTicketData?.status?.includes("Approved") ||
          state?.salaryTicketData?.status?.includes("Completed") ||
          state?.salaryTicketData?.status?.includes("Finance Created")) && (
            <>
              {" "}
              <h1 className="mb-4">Payment Advisories</h1>
              <div className="card px-2 pb-2">
                <CommonTable
                  TableHeading={TableHeading}
                  TableData={pageStates?.VoucherList}
                  ActionData={ActionData}
                  currentPage={pageStates?.currentPage}
                  PageChangeHandler={PageChangeHandler}
                  isLoading={pageStates?.tableLoader}
                  totalPages={pageStates?.totalPages}
                  count={pageStates?.count}
                  handleChangePageSize={handleChangePageSize}
                  pageSize={pageStates?.pageSize}
                />
              </div>
            </>
          )}

        <Logs
          type={"salaryTicket"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </div>

      <ApproveRejectModal
        modal={modal.approveRejectModal}
        toggle={() => toggle("approveReject")}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject" ? "Rejected" : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
      <CreateVoucherModal
        isOpen={modal.createVoucherModel}
        toggle={() => toggle("voucher")}
        EditData={null}
        paymentTicketDetails={state?.salaryTicketData}
        GetPaymentTicketDetail={GetSalaryTicketDetail}
        GetVoucherList={GetVoucherList}
        from="salaryTicket"
      />
      <AlertModal
        modal={alertModal}
        toggle={toggleAlertModal}
        submitHandler={() => toggle("voucher")}
      />
    </>
  );
}
